import Vue from 'vue'
import App from './App.vue'

import './registerServiceWorker'
import router from './router'
import store from './store'

import { CHECK_AUTH } from "./store/actions.type";
import ApiService from "./common/api.service";
import DateFilter from "./common/date.filter";
import ErrorFilter from "./common/error.filter";
import JwtService from "./common/jwt.service";

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3, 
  attempt: 1
});

Vue.config.productionTip = false;
Vue.filter("date", DateFilter);
Vue.filter("error", ErrorFilter);

ApiService.init();

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  store.dispatch('trackOrderHistory')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch(CHECK_AUTH)
      .then(() => {
        if (!JwtService.getToken(JwtService.ID_TOKEN_KEY)) {
          alert('error login status!')
          next({ name: "home" });
        }
        next()
      })
  } else {
    next()
  }
});

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
